import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-shared/uikit/Form";
import { FieldWithCounter } from "../../Properties/Fields/FieldWithCounter";

interface DisplayedTextInputProps {
  formClassName: string;
  name: string;
  translationRoot: string;
}

export const DisplayedTextInput = ({
  name,
  translationRoot,
  formClassName,
}: DisplayedTextInputProps) => (
  <FieldWithCounter
    name={name}
    label={t([translationRoot, "displayed_text"])}
    maxLength={30}
    errorMessage={t([translationRoot, "errors.displayed_text_max_length"])}
  >
    <Form.Item
      className={formClassName}
      name={name}
      translationRoot={translationRoot}
      hideLabel
      hidePlaceholder
      hideBorder
      hideDescription
      rules={{
        maxLength: {
          value: 30,
          message: t([translationRoot, "errors.displayed_text_max_length"]),
        },
      }}
      variant="extra-bottom-margin"
    >
      <Form.Input data-testid="countdown-displayed_text-input" />
    </Form.Item>
  </FieldWithCounter>
);
